(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["_tgtp-block-account-menubutton"] && !Shopify.designMode) return;
  try {
    function accountContentsOpen(mainWrapper, homeContents, insertPoint, contents) {
    if (homeContents) {
      homeContents.style.display = 'none';
    }

    insertPoint.innerHTML = '';
    insertPoint.appendChild(contents.cloneNode(true));

    window.scrollTo(0, 0);

    const closeButton = insertPoint.querySelector('.tgtp-block-account-menubutton-text__closebutton');
    if (closeButton) {
      closeButton.addEventListener('click', function () {
        accountContentsClose(mainWrapper, homeContents, insertPoint);
        const closeUrl = closeButton.getAttribute('data-tgtp-account-menubutton-close-url');
        if (closeUrl && closeUrl !== '') {
          history.pushState({ tgtp_account: 'closed' }, '', closeUrl);
        }
        window.scrollTo(0, 0);
      });
    }
  }

  function accountContentsClose(mainWrapper, homeContents, insertPoint) {
    if (homeContents) {
      homeContents.style.display = '';
    }
    insertPoint.innerHTML = '';
  }

  function matchLinkByQueryParams(link) {
    if (!link || link === '') return false;

    let linkUrl;
    try {
      linkUrl = new URL(link, window.location.origin);
    } catch (e) {
      return false;
    }

    const current = new URL(window.location.href);

    for (const [k, v] of linkUrl.searchParams.entries()) {
      if (!current.searchParams.has(k)) return false;
      if (current.searchParams.get(k) !== v) return false;
    }

    return true;
  }

  function syncViewWithUrl() {
    const buttons = document.querySelectorAll('.tgtp-block-account-menubutton-text__button');
    if (!buttons.length) return;

    const first = buttons[0];
    const mainWrapper = document.querySelector(first.getAttribute('data-tgtp-account-menubutton-main-selector'));
    if (!mainWrapper) return;

    const homeContents = mainWrapper.querySelector(first.getAttribute('data-tgtp-account-menubutton-home-contents-selector'));
    const insertPoint = mainWrapper.querySelector(first.getAttribute('data-tgtp-account-menubutton-insert-contents-selector'));
    if (!insertPoint) return;

    accountContentsClose(mainWrapper, homeContents, insertPoint);

    for (const button of buttons) {
      const link = button.getAttribute('data-tgtp-account-menubutton-link');
      if (!matchLinkByQueryParams(link)) continue;

      const contentsId = button.getAttribute('data-tgtp-account-menubutton-open-id');
      const contentsElem = document.querySelector(
        `.tgtp-block-account-menubutton-text__template[data-tgtp-account-menubutton-contents-id="${contentsId}"]`
      );
      const contents = contentsElem ? contentsElem.content.firstElementChild : null;

      if (contents) {
        accountContentsOpen(mainWrapper, homeContents, insertPoint, contents);
      }
      return;
    }
  }

  document.addEventListener('DOMContentLoaded', function () {
    const buttons = document.querySelectorAll('.tgtp-block-account-menubutton-text__button');

    buttons.forEach(button => {
      button.addEventListener('click', function () {
        const contentsId = button.getAttribute('data-tgtp-account-menubutton-open-id');
        const contentsElem = document.querySelector(
          `.tgtp-block-account-menubutton-text__template[data-tgtp-account-menubutton-contents-id="${contentsId}"]`
        );
        const contents = contentsElem ? contentsElem.content.firstElementChild : null;

        const link = button.getAttribute('data-tgtp-account-menubutton-link');
        const mainWrapper = document.querySelector(button.getAttribute('data-tgtp-account-menubutton-main-selector'));
        const homeContents = mainWrapper.querySelector(button.getAttribute('data-tgtp-account-menubutton-home-contents-selector'));
        const insertPoint = mainWrapper.querySelector(button.getAttribute('data-tgtp-account-menubutton-insert-contents-selector'));

        accountContentsClose(mainWrapper, homeContents, insertPoint);

        if (contents) {
          accountContentsOpen(mainWrapper, homeContents, insertPoint, contents);
          if (link && link !== '') {
            history.pushState({ tgtp_account: 'opened', contentsId }, '', link);
          }
        } else if (link && link !== '') {
          window.location.href = link;
        }
      });
    });

    syncViewWithUrl();

    window.addEventListener('popstate', function () {
      syncViewWithUrl();
    });
  });
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["_tgtp-block-footer-payment-locale"] && !Shopify.designMode) return;
  try {
    document.addEventListener('DOMContentLoaded', function () {
    var forms = document.querySelectorAll('#FooterLanguageForm[data-localization-form]');

    if (!forms.length) return;

    forms.forEach(function (form) {
      var toggle = form.querySelector('[data-localization-toggle]');
      var panel = form.querySelector('[data-localization-panel]');
      var currentLabel = form.querySelector('[data-localization-current]');
      var hiddenInput = form.querySelector('input[name="locale_code"]');
      var options = form.querySelectorAll('[data-localization-option]');

      if (!toggle || !panel || !hiddenInput) return;

      function openPanel() {
        panel.hidden = false;
        toggle.setAttribute('aria-expanded', 'true');
      }

      function closePanel() {
        panel.hidden = true;
        toggle.setAttribute('aria-expanded', 'false');
      }

      function togglePanel() {
        var isExpanded = toggle.getAttribute('aria-expanded') === 'true';
        if (isExpanded) {
          closePanel();
        } else {
          openPanel();
        }
      }

      // トグルボタンで開閉
      toggle.addEventListener('click', function (event) {
        event.preventDefault();
        togglePanel();
      });

      // オプション選択 → hiddenInput 更新 → submit
      options.forEach(function (option) {
        option.addEventListener('click', function (event) {
          event.preventDefault();

          var newValue = option.getAttribute('data-value');
          var newLabel =
            option.getAttribute('data-label') ||
            option.textContent.replace(/\s+/g, ' ').trim();

          if (!newValue) return;

          // 同じ言語ならフォーム送信せず閉じるだけ
          if (newValue === hiddenInput.value) {
            closePanel();
            return;
          }

          hiddenInput.value = newValue;

          if (currentLabel) {
            currentLabel.textContent = newLabel;
          }

          form.submit();
        });
      });

      // 外側クリックで閉じる
      document.addEventListener('click', function (event) {
        if (!form.contains(event.target)) {
          closePanel();
        }
      });

      // ESC キーで閉じる
      document.addEventListener('keydown', function (event) {
        if (event.key === 'Escape' || event.key === 'Esc') {
          closePanel();
        }
      });
    });
  });
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["_tgtp-block-popup-cart-quest"] && !Shopify.designMode) return;
  try {
    // tgtp-popup-cart-quest-selectbox__button--enableかdoneかをcartapiから返ってくるcartattributeで判断したい
// const keyBase = `survey_${surveyId}`;を含むattributeがあるかどうか
// 関数化して、初回読込時と、アンケート送信時に実行しボタンを差し替えられるようにしたい



document.addEventListener('DOMContentLoaded', function() {
  // tgtp-popup-cart-quest-selectbox__button(not disabled) click event
  // when click, open the qa_contents template and insert to tgtp-popup-cart-quest-body
  let selectboxButton = document.querySelectorAll('.tgtp-popup-cart-quest-selectbox__button:not([disabled])');
  if (selectboxButton) {
    selectboxButton.forEach(function(button) {
      button.addEventListener('click', function() {
        let popupCartQuestWindow = button.closest('.tgtp-popup-cart-quest-window');
        let popupCartQuestItem = button.closest('.tgtp-popup-cart-quest-item');
        if( !popupCartQuestWindow || !popupCartQuestItem ) return;

        let popupCartQuestContents = popupCartQuestWindow.querySelector('.tgtp-popup-cart-quest-contents');
        let tgtpPopupCartQuestContentsTemplate = popupCartQuestWindow.querySelector('.tgtp-popup-cart-quest-contents--template');
        let tgtpPopupCartQuestContentsTemplateStep = tgtpPopupCartQuestContentsTemplate ? tgtpPopupCartQuestContentsTemplate.getAttribute('data-tgtp-quest-contents-step') : 1;
        let contentsTemplate = popupCartQuestItem.querySelector('.tgtp-popup-cart-quest-item__contents');

        if( !popupCartQuestContents || !tgtpPopupCartQuestContentsTemplate || !contentsTemplate ) return;

        let contentsClone = contentsTemplate.content.cloneNode(true);
        // insert to tgtp-popup-cart-quest-item
        tgtpPopupCartQuestContentsTemplate.innerHTML = '';
        tgtpPopupCartQuestContentsTemplate.appendChild(contentsClone);

        // setEvent
        addEventTemplate();

        // tgtp-popup-cart-quest-window" data-tgtp-quest-contents-step is set
        popupCartQuestWindow.setAttribute('data-tgtp-quest-selected-contents-step', tgtpPopupCartQuestContentsTemplateStep);
      });
    });
  }

  // tgtp-popup-cart-quest-body__submit-button click event
  // when tgtp-popup-cart-quest-body__back-button, remove cloneNode and contents-step  -1 (max 1)
  // when tgtp-popup-cart-quest-body__submit-button, collect answers and add to cart attributes, then contents-step +1

  function addEventTemplate() {
    let backButtons = document.querySelectorAll('.tgtp-popup-cart-quest-body__back-button');
    backButtons.forEach(function(button) {
      button.addEventListener('click', function() {
        let popupCartQuestWindow = button.closest('.tgtp-popup-cart-quest-window');
        if (!popupCartQuestWindow) return;

        let currentStep = parseInt(popupCartQuestWindow.getAttribute('data-tgtp-quest-selected-contents-step')) || 1;
        let newStep = currentStep - 1;
        if (newStep < 1) newStep = 1;
        popupCartQuestWindow.setAttribute('data-tgtp-quest-selected-contents-step', newStep);
      });
    });



    let submitButtons = document.querySelectorAll('.tgtp-popup-cart-quest-body__submit-button');

submitButtons.forEach(function(button) {
  button.addEventListener('click', async function() {
    console.log('clicked');

    const bodyRoot = button.closest('.tgtp-popup-cart-quest-body');
    const surveyRoot = bodyRoot.querySelector('.tgtp-popup-cart-quest-survey');
    if (!surveyRoot) return;

    // ============================
    //   Survey meta info
    // ============================
    const surveyId = surveyRoot.dataset.tgtpPopupCartQuestSurveyId; // ここをキーとして使う
    const surveyTitle = surveyRoot.dataset.tgtpPopupCartQuestSurveyTitle;
    const couponCode = surveyRoot.dataset.tgtpPopupCartQuestCouponCode;
    const couponDesc = surveyRoot.dataset.tgtpPopupCartQuestCouponDesc;

    // ============================
    //   すべての回答を収集
    // ============================
    let surveyData = {};
    let hasError = false;

    const questions = surveyRoot.querySelectorAll('.tgtp-popup-cart-quest-survey__question');

    questions.forEach((block) => {
      const qid = block.dataset.tgtpCartQuestSurveyId;
      const qtype = block.dataset.tgtpCartQuestSurveyType;
      if (!qid) return;

      let value = null;

      // ---- single_choice / rating ----
      if (qtype === 'single_choice' || qtype === 'rating_5') {
        const checked = block.querySelector('input[type="radio"]:checked');
        if (checked) value = checked.value;
      }

      // ---- multiple_choice ----
      if (qtype === 'multiple_choice') {
        const checkedBoxes = block.querySelectorAll('input[type="checkbox"]:checked');
        value = [...checkedBoxes].map(cb => cb.value);

        // 空配列は未回答扱い
        if (value.length === 0) value = null;
      }

      // ---- multi_text ----
      if (qtype === 'multi_text') {
        const textarea = block.querySelector('textarea');
        if (textarea && textarea.value.trim() !== '') {
          value = textarea.value.trim();
        }
      }

      // ---- matrix_rating_5 ----
      if (qtype === 'matrix_rating_5') {
        let rows = block.querySelectorAll('.tgtp-popup-cart-quest-survey__matrixRow');
        rows.forEach((row) => {
          const rowIndex = row.dataset.rowIndex;
          const checked = row.querySelector('input[type="radio"]:checked');
          if (checked) {
            surveyData[`${qid}_${rowIndex}`] = checked.value;
          } else {
            hasError = true; // 一つでも未回答があればエラー
          }
        });
        return; // matrix はここで終了
      }

      // ---- validation ----
      if (!value) {
        hasError = true;
      } else {
        surveyData[qid] = value;
      }
    });

    // ============================
    // 必須チェック
    // ============================
    if (hasError) {
      alert("未回答の項目があります。すべて回答してください。");
      return;
    }

    // ============================
    // 既存の survey_json を取得
    // ============================
    const cart = await fetch('/cart.js').then(r => r.json());

    // ルートは「配列」を前提にする
    let surveyList = [];

    if (cart.attributes && cart.attributes.survey_json) {
      try {
        const parsed = JSON.parse(cart.attributes.survey_json);

        if (Array.isArray(parsed)) {
          // すでに新フォーマット（配列）の場合
          surveyList = parsed;
        } else if (parsed && typeof parsed === 'object') {
          // 旧フォーマット { id: { survey_head, survey_data }, ... } を
          // 配列に変換しておく（移行用）
          surveyList = Object.keys(parsed).map((key) => {
            return {
              id: key,
              survey_head: parsed[key].survey_head,
              survey_data: parsed[key].survey_data,
            };
          });
        }
      } catch (e) {
        surveyList = [];
      }
    }

    // ============================
    // 今回の回答を作成（id を持たせる）
    // ============================
    const newEntry = {
      id: surveyId,
      survey_head: {
        title: surveyTitle,
        coupon_code: couponCode,
        coupon_desc: couponDesc
      },
      survey_data: surveyData
    };

    // 同じ id の回答が既にあれば差し替えたい場合は一旦除外
    surveyList = surveyList.filter(entry => entry.id !== surveyId);

    // 末尾に追加
    surveyList.push(newEntry);

// ============================
// Cart API へ保存（surveyIdごとに4属性）
// ===========================

// 既存attributesを保持しつつ更新（update.js が attributes 全置換挙動でも事故らないように）
const attrs = { ...(cart.attributes || {}) };

const keyBase = `${surveyId}`;

// 4本を上書き
attrs[`survey_id_${keyBase}`] = String(surveyId || '');
attrs[`survey_title_${keyBase}`] = String(surveyTitle || '');
attrs[`survey_couponcode_${keyBase}`] = String(couponCode || '');
attrs[`survey_coupondesc_${keyBase}`] = String(couponDesc || '');

// body は surveyData を JSON文字列で保存
attrs[`survey_body_${keyBase}`] = JSON.stringify(surveyData);

// 旧データが残っているなら消す（残しておきたいならこの2行は削除）
if (attrs.survey_json != null) attrs.survey_json = ''; // 空文字で削除扱いにするのが一般的 :contentReference[oaicite:0]{index=0}

const payload = { attributes: attrs };

fetch('/cart/update.js', {
  method: 'POST',
  headers: { 'Content-Type': 'application/json' },
  body: JSON.stringify(payload)
})
  .then(res => res.json())
  .then(data => {
    console.log('Survey attrs saved:', data);
    // 次ステップへ
    let popupCartQuestWindow = button.closest('.tgtp-popup-cart-quest-window');
    if (popupCartQuestWindow) {
      let currentStep = parseInt(popupCartQuestWindow.getAttribute('data-tgtp-quest-selected-contents-step')) || 1;
      popupCartQuestWindow.setAttribute('data-tgtp-quest-selected-contents-step', currentStep + 1);
    }
  })
  .catch(err => console.error('Cart update failed:', err));
  });
});

  }

});
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["_tgtp-block-product-detail-description"] && !Shopify.designMode) return;
  try {
    document.addEventListener("DOMContentLoaded", () => {
  const blocks = document.querySelectorAll(".tgtp-block-product-detail-description__content");

  blocks.forEach((block, index) => {
    const type = block.dataset.accordionType;
    const panel = block.querySelector(".tgtp-block-product-detail-description__panel");

    // パネルや type がないものは「アコーディオン対象外」としてスキップ
    if (!panel || !type) return;

    // region の ID をユニークに付与
    const panelId = `tgtp-accordion-panel-${index}`;
    panel.id = panelId;

    if (type === "icon") {
      setupIconAccordion(block, panel, panelId);
    } else if (type === "fade") {
      setupFadeAccordion(block, panel, panelId);
    }
  });
});


function setupIconAccordion(block, panel, panelId) {
  const button = block.querySelector(".tgtp-block-product-detail-description__toggle");

  // 初期状態：閉じている（プラス）
  block.classList.remove("is-open");
  block.classList.add("is-collapsed");
  button.setAttribute("aria-expanded", "false");
  button.setAttribute("aria-controls", panelId);

  button.addEventListener("click", () => {
    const isExpanded = button.getAttribute("aria-expanded") === "true";
    const newExpanded = !isExpanded;

    button.setAttribute("aria-expanded", String(newExpanded));
    block.classList.toggle("is-open", newExpanded);
    block.classList.toggle("is-collapsed", !newExpanded);
  });

}

function setupFadeAccordion(block, panel, panelId) {
  const moreBtn = block.querySelector(".tgtp-block-product-detail-description__more");
  if (!moreBtn) return;

  // デフォルトは閉じている（= is-open 付けない）
  moreBtn.setAttribute("aria-expanded", "false");
  moreBtn.setAttribute("aria-controls", panelId);

  // 初期状態でコンテンツがボタン分以下なら、moreBtnを押した状態と同じにする
  // offset 少し足す
  const offset = 8;
  const textWrapper = block.querySelector(".tgtp-block-product-detail-description__text-wrapper");
  if (textWrapper.scrollHeight <= textWrapper.clientHeight + offset) {
    moreBtn.setAttribute("aria-expanded", "true");
    block.classList.add("is-open");
  }

  moreBtn.addEventListener("click", () => {
    const isExpanded = moreBtn.getAttribute("aria-expanded") === "true";
    const newExpanded = !isExpanded;

    moreBtn.setAttribute("aria-expanded", String(newExpanded));
    block.classList.toggle("is-open", newExpanded);

    // ラベルを変えたい場合
    moreBtn.textContent = newExpanded ? "閉じる" : "もっと見る";
  });
}
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["_tgtp-block-product-detail-similar-product-list"] && !Shopify.designMode) return;
  try {
    (function () {
  let axis = null; // 'x' | 'y' | null
  let startY = 0;
  const LOCK_THRESHOLD = 8;
  const DRAG_THRESHOLD_PX = 10;
  const CLICK_BLOCK_MS = 250;

  function getStepPx(viewport) {
    const first = viewport.querySelector(':scope > li');
    if (!first) return 200;

    const rect = first.getBoundingClientRect();
    const styles = window.getComputedStyle(viewport);
    const gap = parseFloat(styles.columnGap || styles.gap || '0') || 0;
    return Math.round(rect.width + gap);
  }

  function updateArrows(viewport, prevBtn, nextBtn) {
    const max = viewport.scrollWidth - viewport.clientWidth;
    const x = viewport.scrollLeft;
    const EPS = 2;
    if (prevBtn) prevBtn.disabled = x <= EPS;
    if (nextBtn) nextBtn.disabled = x >= max - EPS;
  }

  function initSlider(root) {
  const viewport = root.querySelector('[data-tgtp-pdfc-slider-viewport]');
  if (!viewport) return;

  viewport.addEventListener('dragstart', (e) => {
    e.preventDefault();
  });

  const prevBtn = root.querySelector('[data-tgtp-pdfc-slider-prev]');
  const nextBtn = root.querySelector('[data-tgtp-pdfc-slider-next]');

  const LOCK_THRESHOLD = 8;
  const DRAG_THRESHOLD_PX = 10;
  const CLICK_BLOCK_MS = 250;

  let isDown = false;
  let startX = 0;
  let startY = 0;
  let startScroll = 0;
  let moved = false;
  let blockClickUntil = 0;
  let axis = null;

  // ✅ リンク優先問題の対策：ドラッグ直後は a の click をキャプチャで潰す
  root.querySelectorAll('a').forEach((a) => {
    a.addEventListener('click', (e) => {
      if (Date.now() < blockClickUntil) {
        e.preventDefault();
        e.stopImmediatePropagation();
      }
    }, true); // ← capture
  });

  const setAnchorsDisabled = (disabled) => {
    viewport.querySelectorAll('a').forEach(a => {
      a.style.pointerEvents = disabled ? 'none' : '';
    });
  };

  const scrollByStep = (dir) => {
    viewport.scrollBy({ left: dir * getStepPx(viewport), behavior: 'smooth' });
  };

  prevBtn && prevBtn.addEventListener('click', () => scrollByStep(-1));
  nextBtn && nextBtn.addEventListener('click', () => scrollByStep(1));

  const onScroll = () => updateArrows(viewport, prevBtn, nextBtn);
  viewport.addEventListener('scroll', onScroll, { passive: true });
  window.addEventListener('resize', onScroll);
  onScroll();

  // 追加：どのpointerを追うか
let activePointerId = null;

viewport.addEventListener('pointerdown', (e) => {
  if (e.pointerType === 'mouse' && e.button !== 0) return;

  isDown = true;
  activePointerId = e.pointerId;   // ✅ 追跡
  moved = false;
  axis = null;
  startX = e.clientX;
  startY = e.clientY;
  startScroll = viewport.scrollLeft;

  // ✅ ここでは is-dragging も capture もしない
});

viewport.addEventListener('pointermove', (e) => {
  if (!isDown) return;
  if (activePointerId !== e.pointerId) return;

  const dx = e.clientX - startX;
  const dy = e.clientY - startY;

  // 方向未確定なら判定
  if (!axis) {
    if (Math.abs(dx) < LOCK_THRESHOLD && Math.abs(dy) < LOCK_THRESHOLD) return;

    axis = Math.abs(dx) > Math.abs(dy) ? 'x' : 'y';

    if (axis === 'x') {
      // ✅ 横と確定した瞬間だけ捕まえる
      viewport.classList.add('is-dragging');
      setAnchorsDisabled(true);
      try { viewport.setPointerCapture(e.pointerId); } catch (_) {}
    } else {
      // ✅ 縦はページに任せるので、追跡終了してOK（ここが肝）
      isDown = false;
      activePointerId = null;
      return;
    }
  }

  if (axis === 'x') {
    e.preventDefault(); // ✅ 横のときだけ
    if (!moved && Math.abs(dx) > DRAG_THRESHOLD_PX) moved = true;
    if (moved) viewport.scrollLeft = startScroll - dx;
  }
}, { passive: false });

function endPointer(e) {
  if (!isDown) return;
  if (activePointerId !== e.pointerId) return;

  isDown = false;
  activePointerId = null;
  axis = null;

  setAnchorsDisabled(false);
  

  viewport.classList.remove('is-dragging');
  try { viewport.releasePointerCapture(e.pointerId); } catch (_) {}

  if (moved) blockClickUntil = Date.now() + CLICK_BLOCK_MS;
  moved = false;
  onScroll();
}

viewport.addEventListener('pointerup', endPointer);
viewport.addEventListener('pointercancel', endPointer);


  viewport.addEventListener('click', (e) => {
    if (Date.now() < blockClickUntil) {
      e.preventDefault();
      e.stopImmediatePropagation();
    }
  }, true);
}


  function initAll() {
    document
      .querySelectorAll('[data-tgtp-pdfc-slider]')
      .forEach((root) => {
        if (root.__pdfcSliderInited) return;
        root.__pdfcSliderInited = true;
        initSlider(root);
      });
  }

  document.addEventListener('DOMContentLoaded', initAll);
  window.__tgtpInitProductDetailFetchCollSlider = initAll;
})();



function fetchCollectionSection(fetchUrl, getElementId, productIdAttribute) {
  return fetch(`${fetchUrl}`)
    .then(response => response.text())
    .then(html => {
      const parser = new DOMParser();
      const doc = parser.parseFromString(html, 'text/html');
      const section = doc.getElementById(getElementId);
      if (!section) return '';


      // search productIdAttribute html and set class 'is-selected'
      const productItems = section.querySelectorAll(`[${productIdAttribute}]`);
      const currentProductId = document.querySelector('.tgtp-block-product-detail-similar-product-list')?.getAttribute('data-tgtp-similar-current-product-id');
      
      productItems.forEach(item => {
        const itemProductId = item.getAttribute(productIdAttribute);
        if (itemProductId == currentProductId) {
          // item.classList.add('is-selected');
          // remove the item from the section
          item.remove();
        }
      });

      return section.outerHTML;
    })
    .catch(error => {
      console.error('Error fetching collection section:', error);
      return '';
    });
}

// contents load
document.addEventListener('DOMContentLoaded', function() {
  // get elements has "data-tgtp-similar-collection-url" attribute
  const theCollectionWrapElems = document.querySelectorAll('[data-tgtp-similar-collection-url]');
  theCollectionWrapElems.forEach(container => {
    const collectionUrl = container.getAttribute('data-tgtp-similar-collection-url');
    const fetchParam = container.getAttribute('data-tgtp-similar-fetch-param');
    const getElementId = container.getAttribute('data-tgtp-similar-get-element-id');
    const productIdAttribute = container.getAttribute('data-tgtp-similar-data-attribute-for-get-productid');
    if (collectionUrl && fetchParam && getElementId && productIdAttribute) {
      const fetchUrl = collectionUrl + fetchParam + '&sort_by=price-ascending';
      fetchCollectionSection(fetchUrl, getElementId, productIdAttribute).then(sectionHtml => {
        const innerContainer = container.querySelector('.tgtp-block-product-detail-similar-product-list__container');
        if (sectionHtml.trim() === '') {
          container.style.display = 'none';
        } else {
          container.style.display = 'block';
        }
        if (innerContainer) {
          innerContainer.innerHTML = sectionHtml;
          window.__tgtpInitProductDetailFetchCollSlider?.();
        }
      });
    }
  });
});
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["tgtp-block-product-form"] && !Shopify.designMode) return;
  try {
    function onytptVariantChange(form_wrapper_selector, event, is_cart_add = false) {
    let formWrapperElement = document.querySelector(form_wrapper_selector);
    const productFormElement = event.target.closest('.tgtp-block-product-form');
    if (!formWrapperElement) {
      formWrapperElement = productFormElement;
    }
    const optionValueSelectors = productFormElement.querySelector('.tgtp-block-product-optionvalue');
    productFormElement.classList.add('tgtp-block-product-form--eventnone');

    const ProductUrl = productFormElement.dataset.productUrl;
    const sectionId = productFormElement.dataset.renderingSectionId;
    const buttonTextOptions = JSON.parse(productFormElement.dataset.buttonTextOptions || '{}');

    let selectedOptionValues = [];
    let params = '';

    if (optionValueSelectors) {
      selectedOptionValues = Array.from(
      optionValueSelectors.querySelectorAll('fieldset input:checked')
      ).map(({dataset}) => dataset.optionValueId);
      params = selectedOptionValues.length > 0
        ? `&option_values=${selectedOptionValues.join(',')}`
        : '';
    } else {
      params = '';
    }

    fetch(`${ProductUrl}?section_id=${sectionId}${params}`)
      .then((response) => response.text())
      .then((responseText) => {
      const html = new DOMParser().parseFromString(responseText, 'text/html');
      const newForm = html.querySelector('.tgtp-block-product-form');

      if (!newForm) return;


      if (optionValueSelectors) {
        // 1. input[name="id"]
        const newHiddenInput = newForm.querySelector('input[type="hidden"][name="id"]');
        const currentHiddenInput = formWrapperElement.querySelector('input[type="hidden"][name="id"]');
        if (newHiddenInput && currentHiddenInput) {
          currentHiddenInput.value = newHiddenInput.value;
          // history
          if (newHiddenInput.value) {
            window.history.replaceState({}, '', `${ProductUrl}?variant=${newHiddenInput.value}`); 
          }
        }

        // 2. .tgtp-block-product-optionvalue__radio のclass差し替え
        const newRadios = newForm.querySelectorAll('.tgtp-block-product-optionvalue__radio');
        const currentRadios = formWrapperElement.querySelectorAll('.tgtp-block-product-optionvalue__radio');
        newRadios.forEach((newRadio, i) => {
          const currentRadio = currentRadios[i];
          if (currentRadio) {
            currentRadio.className = newRadio.className;
          }
        });

        // 3. .tgtp-block-product-cart__priceの中身
        const newPrice = newForm.querySelector('.tgtp-block-product-cart__price');
        const currentPrice = formWrapperElement.querySelector('.tgtp-block-product-cart__price');
        if (newPrice && currentPrice) {
          currentPrice.innerHTML = newPrice.innerHTML;
          currentPrice.style.display = 'block';
        } else {
          currentPrice.innerHTML = '';
          currentPrice.style.display = 'none';
        }

        // 4. .tgtp-block-product-cart__infonumberselectの<option> 要素
        const newSelect = newForm.querySelector('.tgtp-block-product-cart__infonumberselectwrapper');
        const currentSelect = formWrapperElement.querySelector('.tgtp-block-product-cart__infonumberselectwrapper');
        if (newSelect && currentSelect) {
          currentSelect.innerHTML = newSelect.innerHTML;
        }
      }

      // 5. .tgtp-block-product-cart__addbuttonのvalue, disabled
      const newButton = newForm.querySelector('.tgtp-block-product-cart__addbutton');
      const currentButton = formWrapperElement.querySelector('.tgtp-block-product-cart__addbutton');
      if (newButton && currentButton) {
        // newButtonの中身のうち、data-button-typeを取得。現在のbuttonTextOptionsから対応するテキストを探し、もし存在すれば書き換える
        const buttonType = newButton.getAttribute('data-button-type');
        if (buttonType && buttonTextOptions[buttonType]) {
          const newButtonText = buttonTextOptions[buttonType];
          const tempDiv = document.createElement('div');
          tempDiv.innerHTML = newButton.innerHTML;
          const buttonTextSpan = tempDiv.querySelector('.tgtp-block-product-cart__addcarttext');
          if (buttonTextSpan) {
            buttonTextSpan.textContent = newButtonText;
            currentButton.innerHTML = tempDiv.innerHTML;
          } else {
            currentButton.innerHTML = newButton.innerHTML;
          }
        } else {
          currentButton.innerHTML = newButton.innerHTML;
        }
        currentButton.disabled = newButton.disabled;
      }

      const newHiddenInputCartAdd = newForm.querySelector('input[type="hidden"][name="id"]');

      // 6. 同じ「name: product-id」を持っているinputを探索、closestのformを探し、そこからtgtp-block-product-cart__addbuttonを取得する
      if (is_cart_add && newHiddenInputCartAdd){
        const variantId = newHiddenInputCartAdd.value;
        document.querySelectorAll(`input[name="id"][value="${variantId}"]`).forEach(function(input) {
          const formElement = input.closest('form');
          if (formElement) {
            const addButton = formElement.querySelector('.tgtp-block-product-cart__addbutton');
            if (newButton && addButton) {
              const buttonType = newButton.getAttribute('data-button-type');
              if (buttonType && buttonTextOptions[buttonType]) {
                const newButtonText = buttonTextOptions[buttonType];
                const tempDiv = document.createElement('div');
                tempDiv.innerHTML = newButton.innerHTML;
                const buttonTextSpan = tempDiv.querySelector('.tgtp-block-product-cart__addcarttext');
                if (buttonTextSpan) {
                  buttonTextSpan.textContent = newButtonText;
                  addButton.innerHTML = tempDiv.innerHTML;
                } else {
                  addButton.innerHTML = newButton.innerHTML;
                }
              } else {
                addButton.innerHTML = newButton.innerHTML;
              }
              addButton.disabled = newButton.disabled;
            }
          }
        });
      }

      // 7. .tgtp-block-product-cart__addgiftのvalue, disabled
      const newGiftButton = newForm.querySelector('.tgtp-block-product-cart__addgift');
      const currentGiftButton = formWrapperElement.querySelector('.tgtp-block-product-cart__addgift');
      if (newGiftButton && currentGiftButton) {
        currentGiftButton.innerHTML = newGiftButton.innerHTML;
        currentGiftButton.disabled = newGiftButton.disabled;
      } else if (currentGiftButton) {
        // currentGiftButton.remove();
      }

      console.log('newForm ', newForm);
      console.log('newGiftButton ', newGiftButton);
      console.log('currentGiftButton ', currentGiftButton);

      productFormElement.classList.remove('tgtp-block-product-form--eventnone');

    });
      
  }


function setupTGTPDelegatedEvents() {
  if (window.__tgtpDelegatedEventsBound) return;
  window.__tgtpDelegatedEventsBound = true;
  // click（カート/ギフト）
  document.addEventListener('click', onTGTPClick, true);
  // change（バリエーション）
  document.addEventListener('change', onTGTPChange, true);
}

function onTGTPChange(event) {
  const optionInput = event.target.closest('.tgtp-block-product-optionvalue input');
  if (!optionInput) return;
  onytptVariantChange('#tgtp-block-product-cart--connectedyt__success', event);
}

function onTGTPClick(event) {
  // カート追加
  const addBtn = event.target.closest('.tgtp-block-product-cart__addbutton');
  if (addBtn) {
    if (addBtn.disabled) return;
    event.preventDefault();
    const form = addBtn.closest('.tgtp-block-product-form');
    if (!form) return;
    const id = form.querySelector('input[name="id"]')?.value;
    const quantity = parseInt(form.querySelector('select[name="quantity"]')?.value || '1', 10);
    if (id && quantity >= 1) {
      const pseudoEvent = { ...event, currentTarget: addBtn, target: event.target };
      tgtpAddCart(id, quantity, pseudoEvent, false);
    }
    return;
  }
  // ギフト追加
  const giftBtn = event.target.closest('.tgtp-block-product-cart__addgift');
  if (giftBtn) {
    if (giftBtn.disabled) return;
    event.preventDefault();
    const form = giftBtn.closest('.tgtp-block-product-form');
    if (!form) return;
    const id = form.querySelector('input[name="id"]')?.value;
    const quantity = parseInt(form.querySelector('select[name="quantity"]')?.value || '1', 10);
    if (id && quantity >= 1) {
      const pseudoEvent = { ...event, currentTarget: giftBtn, target: event.target };
      tgtpAddCart(id, quantity, pseudoEvent, true);
    }
    return;
  }
}


  function tgtpAddCart(id, quantity = 1, event, isGift = false) {
    const button = event.currentTarget;
    button.disabled = true;
    button.classList.add("loading");
    const productFormElement = event.target.closest('.tgtp-block-product-form');

    // bodyにdata属性を追加
    document.body.setAttribute('data-tgtp-cart-processing', 'true');
    

    let formData = {
      "items": [{
        "id": id,
        "quantity": quantity,
        "properties": isGift ? {
          "Option": "GIFT",
          "_CODEdeli": "GIFT"
        } : {}
      }]
    };

    fetch(`${window.Shopify.routes.root}cart/add.js`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json"
      },
      body: JSON.stringify(formData)
    })
    .then(response => {
      if (!response.ok) {
        console.log('Item error to cart:');
        throw new Error("Network response was not ok");

      }
      return response.json();
    })
    .then(data => {
      const productFormElement = event.target.closest('.tgtp-block-product-form');
      const cart_number_class_query = productFormElement.dataset.cartNumberClass;
      const cart_number_class_text_query = productFormElement.dataset.cartNumberClassText;
      
      if (cart_number_class_query && cart_number_class_text_query) {
        const elemCartNumbers = document.querySelectorAll(cart_number_class_query);
        const elemCartNumberTexts = document.querySelectorAll(cart_number_class_text_query);

        if (elemCartNumbers.length > 0 && elemCartNumberTexts.length > 0) {
          // get cart item count
          fetch(`${window.Shopify.routes.root}cart.js`, {
            method: "GET",
            headers: {
              "Content-Type": "application/json"
            }
          }).then(response => {
            if (!response.ok) {
              throw new Error("Network response was not ok");
            }
            return response.json();
          }).then(data => {
            if (data.item_count !== undefined) {
              elemCartNumberTexts.forEach(elemCartNumberText => {
                elemCartNumberText.textContent = data.item_count;
              });
              elemCartNumbers.forEach(elemCartNumber => {
                elemCartNumber.classList.add(`${cart_number_class_query.replace('.', '')}--active`);
              });
            }
          });
        }
      }
      
    })
    .catch(function (error) {
      console.error("Error:", error);
      const elemCartinModal = document.createElement("div");
      elemCartinModal.classList.add("gplp-goods-cartinmodal");
      elemCartinModal.textContent = "在庫状況によりご希望の数量を追加できませんでした。カートページで内容をご確認ください。";
      document.body.appendChild(elemCartinModal);
      
      elemCartinModal.addEventListener("click", function (event) {
        if(elemCartinModal){
          elemCartinModal.remove();
        }
      });

      setTimeout(() => {
        if(elemCartinModal){
          elemCartinModal.remove();
        }
      }, 2000);
    })
    .finally(() => {
        // 数量差し替え
        fetch(`${window.Shopify.routes.root}cart.js`, {
          method: "GET",
          headers: {
            "Content-Type": "application/json"
          }
        }).then(response => {
          if (!response.ok) {
            throw new Error("Network response was not ok");
          }
          return response.json();
        }).then(data => {
          // id: cart-count-bubbleを探して数量を差し替え
          const elemCartCountBubble = document.getElementById("cart-count-bubble");
          
          if (elemCartCountBubble && data.item_count !== undefined) {
            elemCartCountBubble.textContent = data.item_count;
          }
        }
      );
      // onytptchangeのfetchが終わるまで待つ
      onytptVariantChange('#tgtp-block-product-cart--connectedyt__success', event, is_cart_add = true );
      document.body.setAttribute('data-tgtp-cart-processing', 'false');
    });
  }


  document.addEventListener('DOMContentLoaded', function() {
    setupTGTPDelegatedEvents();
  });
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["tgtp-block-slider"] && !Shopify.designMode) return;
  try {
    (() => {
  // ---------------------------
  // 1) Global Swiper loader (load at most once, never overwrite existing Swiper)
  // ---------------------------
  window.__TGTP__ = window.__TGTP__ || {};
  if (!window.__TGTP__.loadSwiper) {
    window.__TGTP__.loadSwiper = function loadSwiper() {
      if (window.Swiper) return Promise.resolve(window.Swiper);
      if (window.__TGTP__.__swiperPromise) return window.__TGTP__.__swiperPromise;

      const holder = document.querySelector('[data-tgtp-swiper-src]');
      const src = holder?.dataset?.tgtpSwiperSrc;

      window.__TGTP__.__swiperPromise = new Promise((resolve, reject) => {
        if (!src) return reject(new Error('TGTP: swiper src not found (data-tgtp-swiper-src)'));

        const s = document.createElement('script');
        s.src = src;
        s.async = true;
        s.onload = () => window.Swiper ? resolve(window.Swiper) : reject(new Error('TGTP: Swiper loaded but window.Swiper missing'));
        s.onerror = () => reject(new Error('TGTP: Failed to load Swiper script'));
        document.head.appendChild(s);
      });

      return window.__TGTP__.__swiperPromise;
    };
  }

  // ---------------------------
  // 2) Slider init (scoped by data attributes)
  // ---------------------------
  const ROOT_SEL = '[data-tgtp-slider]';
  const instances = new WeakMap();

  const safeParseJSON = (str, fallback = null) => {
    if (!str) return fallback;
    try { return JSON.parse(str); } catch { return fallback; }
  };



// ---------------------------
// Fixed bullets pagination for loop + duplicated slides
// (keep bullets count = original slides count, and sync via realIndex)
// ---------------------------
const setupFixedLoopBullets = (swiper, pagEl, originalCount) => {
  if (!swiper || !pagEl || !originalCount) return;
  // build bullets
  pagEl.innerHTML = '';
  const frag = document.createDocumentFragment();
  for (let i = 0; i < originalCount; i++) {
    const b = document.createElement('span');
    b.className = 'swiper-pagination-bullet';
    b.type = 'button';
    b.setAttribute('role', 'button');
    b.setAttribute('aria-label', `Go to slide ${i + 1}`);
    b.addEventListener('click', () => {
      // slideToLoop maps "real" index to correct looped slide
      if (typeof swiper.slideToLoop === 'function') swiper.slideToLoop(i);
      else swiper.slideTo(i);
    });
    frag.appendChild(b);
  }
  pagEl.appendChild(frag);
  const syncActive = () => {
    const idx = (swiper.realIndex ?? swiper.activeIndex ?? 0) % originalCount;
    const bullets = pagEl.querySelectorAll('.swiper-pagination-bullet');
    bullets.forEach((el, i) => {
      if (i === idx) el.classList.add('swiper-pagination-bullet-active');
      else el.classList.remove('swiper-pagination-bullet-active');
    });
  };
  // initial + on change
  syncActive();
  swiper.on('realIndexChange', syncActive);
  swiper.on('slideChange', syncActive);
};


  // ---------------------------
  // Loop slide count normalizer
  // (satisfy Swiper loop constraints by cloning until valid)
  // ---------------------------
  const gcd = (a, b) => {
    a = Math.abs(a || 0); b = Math.abs(b || 0);
    while (b) [a, b] = [b, a % b];
    return a || 1;
  };
  const lcm = (a, b) => Math.abs((a || 1) * (b || 1)) / gcd(a || 1, b || 1);

  const destroy = (root) => {
    const state = instances.get(root);
    if (!state) return;

    [state.mainEl, state.thumbEl].forEach(el => {
      if (el?.__swiper?.destroy) {
        el.__swiper.destroy(true, true);
        el.__swiper = null;
      }
    });
    instances.delete(root);
  };

  const init = async (root) => {
    if (!root || instances.has(root)) return;

    // wait for Swiper availability (load once globally)
    try {
      await window.__TGTP__.loadSwiper();
    } catch (e) {
      // If Swiper fails to load, do not keep slider hidden forever
      root.querySelectorAll('.tgtp-block-slider__contents').forEach(el => el.style.visibility = 'visible');
      return;
    }

    const cfg = safeParseJSON(root.dataset.config, {});
    const mainEl = root.querySelector('[data-tgtp-main]');
    const thumbEl = root.querySelector('[data-tgtp-thumb]');
    if (!mainEl || mainEl.__swiper) return;

    let thumbSwiper = null;

    if (cfg?.hasThumbs && thumbEl && !thumbEl.__swiper) {
      const nextThumb = root.querySelector('.tgtp-block-slider__thumb-contents .swiper-button-next');
      const prevThumb = root.querySelector('.tgtp-block-slider__thumb-contents .swiper-button-prev');

      thumbEl.__swiper = new window.Swiper(thumbEl, {
        loop: !!cfg.thumb?.loop,
        centeredSlides: !!cfg.thumb?.centeredSlides,
        slidesPerView: cfg.thumb?.perViewMobile ?? 4,
        spaceBetween: cfg.thumb?.spaceMobile ?? 8,
        watchSlidesProgress: true,
        observer: true,
        observeParents: true,
        updateOnWindowResize: true,
        preventClicks: false,
        preventClicksPropagation: false,
        ...(cfg.thumb?.navigation ? { navigation: { nextEl: nextThumb, prevEl: prevThumb } } : {}),
        breakpoints: {
          767: {
            slidesPerView: cfg.thumb?.perViewTablet ?? (cfg.thumb?.perViewSmallPC ?? cfg.thumb?.perView ?? (cfg.thumb?.perViewMobile ?? 4)),
            spaceBetween: cfg.thumb?.space ?? (cfg.thumb?.spaceMobile ?? 8)
          },
          1024: {
            slidesPerView: cfg.thumb?.perViewSmallPC ?? (cfg.thumb?.perView ?? (cfg.thumb?.perViewMobile ?? 4)),
            spaceBetween: cfg.thumb?.space ?? (cfg.thumb?.spaceMobile ?? 8)
          },
          1280: {
            slidesPerView: cfg.thumb?.perView ?? (cfg.thumb?.perViewMobile ?? 4),
            spaceBetween: cfg.thumb?.space ?? (cfg.thumb?.spaceMobile ?? 8)
          }
        }
      });

      thumbSwiper = thumbEl.__swiper;
    } else if (thumbEl?.__swiper) {
      thumbSwiper = thumbEl.__swiper;
    }

    const nextMain = root.querySelector('.tgtp-block-slider__main-contents .swiper-button-next');
    const prevMain = root.querySelector('.tgtp-block-slider__main-contents .swiper-button-prev');
    const pagEl = root.querySelector('.tgtp-block-slider__main-contents .swiper-pagination');
    const mainOriginalCount = Number(root.dataset.mainOriginalCount || 0) || 0;


    mainEl.__swiper = new window.Swiper(mainEl, {
      loop: !!cfg.main?.loop,
      centeredSlides: !!cfg.main?.centeredSlides,
      slidesPerView: cfg.main?.perViewMobile ?? 1,
      spaceBetween: cfg.main?.spaceMobile ?? 10,
      observer: true,
      observeParents: true,
      updateOnWindowResize: true,
      preventClicks: false,
      preventClicksPropagation: false,
      // ---- allow nested scroll area to handle drag ----
      noSwiping: cfg.main?.noSwipingSelector ? true : false,
      // Swiper v6+ supports selector. If your Swiper doesn't, the allowTouchMove toggle (diff3) will still work.
      noSwipingSelector: cfg.main?.noSwipingSelector || null,
      // NOTE: loop + duplicated slides increases bullets, so we render fixed bullets ourselves
      ...((cfg.pagination === 'dots' || cfg.pagination === 'dots-active-long') && !(cfg.main?.loop)
        ? { pagination: { el: pagEl, clickable: true } }
        : {}),
      ...(cfg.main?.navigation ? { navigation: { nextEl: nextMain, prevEl: prevMain } } : {}),
      ...(cfg.pagination === 'thumbs' && thumbSwiper ? { thumbs: { swiper: thumbSwiper } } : {}),

      breakpoints: {
        767: {
          slidesPerView: cfg.main?.perViewTablet ?? (cfg.main?.perViewSmallPC ?? cfg.main?.perView ?? (cfg.main?.perViewMobile ?? 1)),
          spaceBetween: cfg.main?.space ?? (cfg.main?.spaceMobile ?? 10)
        },
        1024: {
          slidesPerView: cfg.main?.perViewSmallPC ?? (cfg.main?.perView ?? (cfg.main?.perViewMobile ?? 1)),
          spaceBetween: cfg.main?.space ?? (cfg.main?.spaceMobile ?? 10)
        },
        1280: {
          slidesPerView: cfg.main?.perView ?? (cfg.main?.perViewMobile ?? 1),
          spaceBetween: cfg.main?.space ?? (cfg.main?.spaceMobile ?? 10)
        }
      }
    });
    
    // fixed bullets for loop mode (keep bullets count = original slides count)
    if ((cfg.pagination === 'dots' || cfg.pagination === 'dots-active-long') && cfg.main?.loop && pagEl) {
      setupFixedLoopBullets(mainEl.__swiper, pagEl, mainOriginalCount);
    }

    // final safety: never remain hidden
    setTimeout(() => {
      root.querySelectorAll('.tgtp-block-slider__contents').forEach(el => {
        if (!el.classList.contains('swiper-initialized')) el.style.visibility = 'visible';
      });
    }, 2000);

    instances.set(root, { mainEl, thumbEl });
  };

  const refreshSwiper = (root) => {
    if (!root) return;

    const mainEl = root.querySelector('[data-tgtp-main]');
    const thumbEl = root.querySelector('[data-tgtp-thumb]');
    const main = mainEl?.__swiper;
    const thumb = thumbEl?.__swiper;

    const refreshOne = (sw) => {
      if (!sw) return;

      // まず通常更新
      sw.update();

      // loopの場合は slides/duplicate の整合が崩れやすいので再生成
      if (sw.params?.loop) {
        // Swiperのバージョン差分を吸収
        try {
          sw.loopDestroy?.();
          sw.loopCreate?.();
        } catch (e) {}
        sw.update();
      }
    };

    refreshOne(thumb);
    refreshOne(main);

    // thumbs連動してる場合、thumb更新後に main の thumbs を噛み直す方が安定することがある
    if (main?.params?.thumbs?.swiper && thumb) {
      main.thumbs?.init?.();
      main.thumbs?.update?.();
    }
  };


  const initAll = (scope = document) => {
    scope.querySelectorAll(ROOT_SEL).forEach((root) => init(root));
  };

  // DOM ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initAll(), { once: true });
  } else {
    initAll();
  }

  // catch slide updates
  document.addEventListener('tgtp:slides:updated', (e) => {
    const root = e.detail?.root;
    if (!root) return;
    refreshSwiper(root);
  });


  // Theme editor support
  document.addEventListener('shopify:section:load', (e) => initAll(e.target || document));
  document.addEventListener('shopify:section:unload', (e) => {
    const scope = e.target || document;
    scope.querySelectorAll(ROOT_SEL).forEach(destroy);
  });
  // expose helpers (add once)
  window.__TGTP__ = window.__TGTP__ || {};
  window.__TGTP__.initSliders = initAll;        // scopeを渡して初期化
  window.__TGTP__.destroySlider = destroy;      // root単位で破棄
  window.__TGTP__.refreshSlider = refreshSwiper;// root単位で更新

})();
  } catch(e) { console.error(e); }
})();

})();
